var _path, _g, _path2, _path3, _path4, _path5, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoScrapedPostsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 198,
    viewBox: "0 0 208 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5329_2085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5104",
    d: "M71 197.215L39 177.215L0 23.2148L159.5 0.714844L192.5 183.715L71 197.215Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5329_2085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 5102",
    filter: "url(#filter0_d_5329_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 18.0224L19.5074 33.2799C15.4588 33.7841 12.6976 37.6298 13.5141 41.6271L44.202 191.86C44.9343 195.445 48.3044 197.862 51.9349 197.405L173.07 182.15C177.09 181.644 179.842 177.841 179.066 173.865L149.751 23.6282C149.047 20.017 145.667 17.5677 142.016 18.0224Z",
    fill: "url(#paint0_linear_5329_2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 18.0224L19.5074 33.2799C15.4588 33.7841 12.6976 37.6298 13.5141 41.6271L44.202 191.86C44.9343 195.445 48.3044 197.862 51.9349 197.405L173.07 182.15C177.09 181.644 179.842 177.841 179.066 173.865L149.751 23.6282C149.047 20.017 145.667 17.5677 142.016 18.0224Z",
    fill: "url(#paint1_linear_5329_2085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 18.0224L19.5074 33.2799C15.4588 33.7841 12.6976 37.6298 13.5141 41.6271L44.202 191.86C44.9343 195.445 48.3044 197.862 51.9349 197.405L173.07 182.15C177.09 181.644 179.842 177.841 179.066 173.865L149.751 23.6282C149.047 20.017 145.667 17.5677 142.016 18.0224Z",
    stroke: "white"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5103",
    d: "M67.5 194.715L41.5 178.715L57.4875 175.624C61.4424 174.86 65.225 177.582 65.7552 181.575L67.5 194.715Z",
    fill: "#C7D2F6",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5108 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.463 72.6753C143.761 74.8643 142.228 76.8803 140.04 77.1783L44.5395 90.1783C42.3506 90.4763 40.3345 88.9433 40.0365 86.7544C39.7386 84.5654 41.2715 82.5494 43.4605 82.2514L138.96 69.2514C141.149 68.9534 143.165 70.4864 143.463 72.6753Z",
    fill: "url(#paint2_linear_5329_2085)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5110 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.966 97.693C132.254 99.8833 130.712 101.892 128.522 102.181L52.5218 112.181C50.3316 112.469 48.3224 110.927 48.0342 108.737C47.746 106.546 49.2879 104.537 51.4782 104.249L127.478 94.249C129.668 93.9608 131.678 95.5027 131.966 97.693Z",
    fill: "url(#paint3_linear_5329_2085)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5107 (Stroke)",
    opacity: 0.91,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.462 49.6672C137.765 51.8555 136.236 53.8747 134.048 54.1772L72.5476 62.6772C70.3593 62.9796 68.3401 61.4508 68.0377 59.2625C67.7352 57.0741 69.264 55.055 71.4524 54.7525L132.952 46.2525C135.141 45.9501 137.16 47.4789 137.462 49.6672Z",
    fill: "url(#paint4_linear_5329_2085)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vector 5115",
    filter: "url(#filter1_d_5329_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0637 29.5785L49.58 27.3328C50.0989 27.2663 50.5814 27.6109 50.6867 28.1234L58 63.7148L47 59.2148L38.5 67.2148L31.2103 30.7665C31.0966 30.1979 31.4887 29.6522 32.0637 29.5785Z",
    fill: "#4C95FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2617"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 128,
    y: 93.7148,
    width: 80,
    height: 82
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5329_2085_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 247",
    filter: "url(#filter2_d_5329_2085)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133.715,
    r: 36,
    fill: "url(#paint5_linear_5329_2085)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group 2434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.16 116.888C180.725 115.324 183.262 115.324 184.826 116.888C186.391 118.453 186.391 120.99 184.826 122.555L173.666 133.715L184.826 144.875C186.391 146.44 186.391 148.977 184.826 150.541C183.262 152.106 180.725 152.106 179.16 150.541L168 139.381L156.84 150.541C155.275 152.106 152.738 152.106 151.174 150.541C149.609 148.977 149.609 146.44 151.174 144.875L162.334 133.715L151.174 122.555C149.609 120.99 149.609 118.453 151.174 116.888C152.738 115.324 155.275 115.324 156.84 116.888L168 128.048L179.16 116.888Z",
    fill: "#4C95FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5329_2085",
    x: 8.87061,
    y: 13.4683,
    width: 174.827,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5329_2085",
    x: 28.1907,
    y: 27.3247,
    width: 30.8093,
    height: 43.8901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5329_2085",
    x: 128,
    y: 93.7148,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5329_2085_clip_path",
    transform: "translate(-128 -93.7148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133.715,
    r: 36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5329_2085",
    x1: 96.25,
    y1: 17.2148,
    x2: 96.25,
    y2: 198.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5329_2085",
    x1: 96.25,
    y1: 17.2148,
    x2: 96.25,
    y2: 198.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5329_2085",
    x1: 150,
    y1: 73.2148,
    x2: 44,
    y2: 86.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5329_2085",
    x1: 142,
    y1: 90.7148,
    x2: 48,
    y2: 103.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5329_2085",
    x1: 157.5,
    y1: 48.7148,
    x2: 50,
    y2: 58.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5329_2085",
    x1: 132,
    y1: 127.715,
    x2: 208.5,
    y2: 151.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoScrapedPostsIllustration);
export default __webpack_public_path__ + "static/media/noScrapedPostsIllustration.d3cbd384cee6a439d5778d3e7f885191.svg";
export { ForwardRef as ReactComponent };